export var MPAOperationType;
(function (MPAOperationType) {
    MPAOperationType["MPA_OPERATION_TYPE_MPA_OPERATION_DELETE_BACKUP_POLICY"] = "MPA_OPERATION_DELETE_BACKUP_POLICY";
    MPAOperationType["MPA_OPERATION_TYPE_MPA_OPERATION_RESTORE_RESOURCE"] = "MPA_OPERATION_RESTORE_RESOURCE";
})(MPAOperationType || (MPAOperationType = {}));
